module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADuSURBVHgB7ZbBDYJAEEWHjQVQAiVYgnaiR07agViBJ0LgsnagHRgrsAVa8AoB/JtoYsjCemDXTZh3YWGA/TuTPxkihmFmRqB7mGXZBpeI7FLGcXwmkyAlRgghyQFt2277ogR5hnclYyYDZYzIAQvTC1LKsK7rS9M0d9wmZJlRl6Vpuqyq6tF13YocMZihoih2EJJgGeriEzhR6zKtoDzPTxCzpwGmap74D/3UGNFBn/QngqEAsqQydKB3ySDyiNMkn7itkgVjXyirozQ3tXFfkC1GXQYBJYSssbySb7hqjIwJnhi/4YnRAE+MDMMoXu3ecIO7xE0VAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_changeMenu.png
// module id = ZQii
// module chunks = 58